import React, {useState} from "react";
import styled from "styled-components";
import Button from "../Shared/Button";
import Table from "../Shared/Table";
import {UseAppSelector} from "../../redux/configure-store";
import useLocalizePhrase from "../../utils/useLocalizePhrase";
import {
    getDefinedParticipantBenesArray, getDefinedParticipantLastBeneUpdateDate
} from "../../redux/profile/selectors";

const StyledBeneInfo = styled.div`
  margin-top: 24px;
  padding: 32px 40px;
  background-color: #fff;
  @media only screen and (max-width: 480px) {
    margin-top: 16px;
  }
  @media (max-width: 768px) {
    padding: 32px 24px;
  }
  @media (max-width: 640px) {
    padding: 24px;
  }
`;

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-bottom: 1px solid #bec3c8;
  padding-bottom: 7px;
  margin-bottom: 24px;
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
const StyledHeader = styled.div`
  font-family: "Nimbus Sans Novus Bold";
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  color: #3b4b59;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const StyledDate = styled.div`
  font-family: "Nimbus Sabs Novus";
  font-size: 16px;
  color: #3b4b59;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const StyledPlanName = styled.div`
  font-family: "Nimbus Sans Novus Regular";
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.03px;
  color: #3b4b59;
  margin-bottom: 24px;
  margin-top: 24px;
  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const StyledButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 640px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const StyledLinkButton = styled.div`
  margin-right: 16px;
  padding: 12px 0 10px;
  @media (max-width: 640px) {
    margin-right: 0;
  }
`;


export const PensionBeneficiariesCard = () => {
    const [ showMore, setShowMore] = useState(false);
    const definedParticipantBenesArray = UseAppSelector(getDefinedParticipantBenesArray);
    const beneDate = UseAppSelector(getDefinedParticipantLastBeneUpdateDate);
    const finalDate = new Date(beneDate);
    const day = finalDate.getDate();
    const month = finalDate.getMonth() + 1;
    const year = finalDate.getFullYear();
    const formattedDate = month + '/' + day + '/' + year;
    const headerNames = ["TYPE", "NAME", "DISTRIBUTION %"];
    const pensionBeneficiaryTitle = useLocalizePhrase('Pension Beneficiaries');
    const asOfTitle = useLocalizePhrase('As of');

    let pensionBeneficiary = _.groupBy(definedParticipantBenesArray,  'planName');
    const plansList = Object.keys(pensionBeneficiary);

    plansList.forEach((planName) => {
        const planDetailsList = pensionBeneficiary[planName];
        pensionBeneficiary[planName] = {
            primaryPlans: [],
            allPlans: [],
            hasOnlyPrimary: false
        };
        const filteredPlans = planDetailsList.filter(record => record.beneType !== 'tertiary');
        const primaryArray =  filteredPlans.filter(record =>record.beneType.toLowerCase() === "primary");
        const secondaryArray =  filteredPlans.filter(record =>record.beneType.toLowerCase() === "secondary");
        const allPlansArray = primaryArray.concat(secondaryArray);
        pensionBeneficiary[planName].primaryPlans = primaryArray.map(record =>  [
            {name:"type", value: record.beneType},
            {name: "name", value: record.firstName.toLowerCase().replace(/\b\w/g, (s: string) => s.toUpperCase()) + " " + record.lastName.toLowerCase().replace(/\b\w/g, (s: string) => s.toUpperCase())},
            {name: "distribution", value: record.designatedPercent*100}
            ]
        );
        pensionBeneficiary[planName].allPlans = allPlansArray.map(record =>  [
                {name:"type", value: record.beneType},
                {name: "name", value: record.firstName.toLowerCase().replace(/\b\w/g, (s: string) => s.toUpperCase())
                + " " + record.lastName.toLowerCase().replace(/\b\w/g, (s: string) => s.toUpperCase())
              },
                {name: "distribution", value: record.designatedPercent*100}
            ]
        );
        pensionBeneficiary[planName].hasOnlyPrimary = (primaryArray.length === 1 || primaryArray.length === 2) && secondaryArray.length === 0;

    });
    const pensionBeneTableData = Object.keys(pensionBeneficiary).map((planName) => {
            return {
                name: planName,
                primaryPlans: pensionBeneficiary[planName].primaryPlans,
                allPlans: pensionBeneficiary[planName].allPlans,
                hasOnlyPrimary: pensionBeneficiary[planName].hasOnlyPrimary
            }
    });
    const showViewAll = pensionBeneTableData.find((plan) => !plan.hasOnlyPrimary);
    return (
            <StyledBeneInfo>
                <StyledHeaderContainer>
                    <StyledHeader>
                      {pensionBeneficiaryTitle}
                    </StyledHeader>
                    <StyledDate>
                      {asOfTitle} {formattedDate}
                    </StyledDate>
                </StyledHeaderContainer>
                <>
                    {pensionBeneTableData && pensionBeneTableData.map((plan) => {
                        return (
                            <>
                                <StyledPlanName>
                                    {plan.name}
                                </StyledPlanName>
                                {definedParticipantBenesArray.length > 0 &&
                                    <Table isBeneCard borderless={true} headerNames={headerNames} tableColumnData={showMore ? plan.allPlans : plan.primaryPlans.slice(0,Math.min(2,plan.primaryPlans.length))}/>
                                }
                            </>
                        )
                    })
                    }
                </>

                {definedParticipantBenesArray.length > 0 &&
                    <StyledButtonContainer>
                        {showViewAll && <StyledLinkButton>
                            <Button variant="tertiary" isLink={true} buttonTitle={!showMore ? "View All" : "View Less"}
                                    onBeaconClick={() => setShowMore(!showMore)}/>
                        </StyledLinkButton>
                        }
                    </StyledButtonContainer>
                }

            </StyledBeneInfo>
    )
}